import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TokenService {
  TOKEN_KEY = "token";
  USER_ID_KEY = "id_user";
  
  token: string = "";
  public tokenSubject = new BehaviorSubject<string>(null);
  userId: string = "";
  basicTokenB64: string = "";

  constructor() { }

  setToken(userId: string, token: string) {
    this.token = token;
    this.tokenSubject.next(this.token);
    window.localStorage.setItem(this.TOKEN_KEY, token);

    this.userId = userId;
    window.localStorage.setItem(this.USER_ID_KEY, userId);

    this.makeBasicTokenB64();
  }

  getToken() {
    if (!this.token) {
      const tokenLocalStorage = window.localStorage.getItem(this.TOKEN_KEY);
      if (tokenLocalStorage !== null) {
        this.token = tokenLocalStorage;
        this.tokenSubject.next(this.token);
      }

      const userIdStorage = window.localStorage.getItem(this.USER_ID_KEY);
      if (userIdStorage !== null) {
        this.userId = userIdStorage;
      }

      this.makeBasicTokenB64();
    }
    return this.token;
  }

  removeToken() {
    this.token = "";
    this.userId = "";
    this.basicTokenB64 = "";
    window.localStorage.removeItem(this.TOKEN_KEY);
    window.localStorage.removeItem(this.USER_ID_KEY);
    this.tokenSubject.next(null);
  }

  getTokenB64() {
    return this.basicTokenB64;
  }

  private makeBasicTokenB64() {
    this.basicTokenB64 = btoa(`${this.userId}:${this.token}`);
  }
}
